DatePickerView = require 'app/scripts/views/card/date-picker-view'
Label = require 'app/scripts/models/label'
ModelCacheListener = require 'app/scripts/views/internal/model-cache-listener'
PopOver = require 'app/scripts/views/lib/pop-over'
React = require 'react'
$ = require 'jquery'
t = require('app/scripts/views/internal/recup-with-helpers')('home_up_next')
{ trackUe } = require '@trello/analytics'
{ CanonicalCard } = require 'app/scripts/views/canonical-card/canonical-card-components'
{ CanonicalDetail } = require 'app/scripts/views/canonical-detail/canonical-detail-components'
{ BoardAndDetailContainer } = require('@atlassian/trello-canonical-components').CanonicalDetail
{ getOverflowItems, DUE_DATE_TYPE } = require 'app/scripts/views/home/overflow-menu'

class DueDate extends React.Component
  displayName: 'DueDate'

  componentDidMount: ->
    @listenOnCardChange()

  componentDidUpdate: (prevProps) ->
    if prevProps.cardId != @props.cardId
      @props.clearModelListeners()
      @listenOnCardChange()

  listenOnCardChange: =>
    card = @getModelFromModelCache('Card', @props.cardId)
    @props.modelListener card, 'change', =>
      if !card.getDueDate()
        @props.removeDueDateCard(@props.cardId)

      @forceUpdate()

  getModelFromModelCache: (type, id) =>
    @props.modelCache.get(type, id)

  trackOverflowMenuOpens: =>
    { cardId, orgId } = @props

    trackUe('home', 'opens', 'overflow menu', '', '', 'by clicking overflow menu icon on due dates card', { cardId, teamId: orgId })

  onCompleteClick: =>
    { cardId, orgId, removeDueDateCard } = @props

    trackUe('home', 'completes', 'card', '', '', 'by clicking complete button on due dates card', { cardId, teamId: orgId })
    @getModelFromModelCache('Card', cardId).update({ dueComplete: true })

    removeDueDateCard(cardId)

  onChangeDueDateClick: (event) =>
    { cardId, orgId, modelCache } = @props

    trackUe('home', 'changes', 'due date', '', '', 'by clicking change date button on due dates card', { cardId, teamId: orgId })

    event.preventDefault()
    card = @getModelFromModelCache('Card', cardId)

    PopOver.toggle
      view: DatePickerView
      options: { model: card, modelCache, trackingCategory: 'team cards with due dates' }
      elem: $(event.currentTarget)

  trackOnClickCanonicalCard: =>
    { cardId, orgId } = @props

    trackUe('home', 'opens', 'card', '' , '', 'by clicking card in due dates feed', { cardId, teamId: orgId })

  render: t.renderable ->
    { boardId, cardId, listId, modelCache, orgId } = @props

    board = @getModelFromModelCache('Board', boardId)
    card = @getModelFromModelCache('Card', cardId)
    list = @getModelFromModelCache('List', listId)
    org = @getModelFromModelCache('Organization', orgId)

    t.tag BoardAndDetailContainer, { width: 420 }, =>
      t.div { onClick: @trackOnClickCanonicalCard }, =>
        t.tag CanonicalCard, {
          board
          boardClassName: 'canonical-stretch'
          canRemove: false
          card
          cardClassName: 'canonical-stretch'
          labels: card.getLabels()?.sort(Label.compare)
          list
          lightBackground: true
          members: card.memberList?.models
          numNotifications: 0
          organization: org
        }

      t.div =>
        t.tag CanonicalDetail, {
          dueSoon: true
          @trackOverflowMenuOpens
          board
          cardId
          dueDate: card.get('badges')?.due
          onChangeDueDateClick: card.editable() && @onChangeDueDateClick
          onCompleteClick: card.editable() && @onCompleteClick
          overflowMenuItems: getOverflowItems(card, DUE_DATE_TYPE, modelCache, @trackingPrepositionalObject, @trackingIndirectObject)
        }

module.exports = ModelCacheListener(DueDate)
